import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Geolocation from './Geolocation'
import {
  About,
  Accessibility,
  AccountAddresses,
  Account,
  AccountAllergens,
  AccountCreditCards,
  AccountDelete,
  AccountGiftCards,
  AccountSettings,
  Category,
  Catering,
  CateringSite,
  Checkout,
  CheckoutGuest,
  CheckoutSignIn,
  CheckoutSignUp,
  CommsPrefs,
  Confirmation,
  Deals,
  Donations,
  Favorites,
  Fulfillment,
  GiftCards,
  GroupOrderGuest,
  GroupOrderReview,
  GroupOrders,
  History,
  Home,
  HouseAccounts,
  Item,
  Locations,
  Loyalty,
  Landing,
  Menu,
  MenuDeals,
  MenuFavorites,
  MenuFeatured,
  MenuRecents,
  MenuSite,
  NotFound,
  Order,
  OrderHistory,
  OrderType,
  PointsShop,
  Profile,
  Punchh,
  QR,
  Quote,
  Rating,
  Refunds,
  ResetPassword,
  RevenueCenters,
  RevenueCenter,
  Rewards,
  SignUp,
  Thanx,
  Upsell,
  Vendor,
  VerifyAccount,
  Unsubscribe,
  ClaimPoints,
} from './pages'
import MenuNew from './pages/Menu/MenuNew'
import { useEffect } from 'react'
import { sendPageView } from 'app/analytics'
import { selectBrand, selectCustomer, useAppSelector } from '@open-tender/cloud'
let eventTimeout: NodeJS.Timeout
const AppRoutes = () => {
  const location = useLocation()
  const { profile } = useAppSelector(selectCustomer)
  const brand = useAppSelector(selectBrand)
  useEffect(() => {
    clearTimeout(eventTimeout)
    eventTimeout = setTimeout(() => {
      sendPageView({ customer: profile, brand })
    }, 500)
  }, [brand, location, profile])

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="thanx/callback" element={<Thanx />} />
      <Route path="punchh" element={<Punchh />} />
      <Route path="qr/:id" element={<QR />} />
      <Route path="unsubscribe" element={<Unsubscribe />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="verify" element={<VerifyAccount />} />
      <Route path="signup" element={<SignUp />} />
      <Route path="guest" element={<Landing />} />
      <Route element={<Geolocation />}>
        <Route path="menu" element={<MenuSite />} />
        <Route path="restaurants" element={<Locations />} />
        <Route path="catering" element={<CateringSite />} />
        <Route path="about" element={<About />} />
      </Route>
      <Route element={<Geolocation />}>
        <Route path="order-type" element={<OrderType />} />
        <Route path="catering-address" element={<Catering />} />
        <Route path="locations" element={<RevenueCenters />} />
      </Route>
      <Route path="locations/:slug" element={<RevenueCenter />} />
      <Route path="menu/:slug" element={<Menu />}>
        <Route index element={<MenuNew />} />
        <Route path="featured" element={<MenuFeatured />} />
        <Route path="favorites" element={<MenuFavorites />} />
        <Route path="recents" element={<MenuRecents />} />
        <Route path="deals" element={<MenuDeals />} />
        <Route path="vendor/:vendorSlug" element={<Vendor />} />
        <Route path="category/:categorySlug" element={<Category />} />
        <Route path="item/:itemSlug" element={<Item />} />
      </Route>
      <Route path="join/:token" element={<GroupOrderGuest />} />
      <Route path="add-ons" element={<Upsell />} />
      <Route path="review" element={<GroupOrderReview />} />
      <Route path="checkout">
        <Route index element={<Checkout />} />
        <Route path="guest" element={<CheckoutGuest />} />
        <Route path="signin" element={<CheckoutSignIn />} />
        <Route path="signup" element={<CheckoutSignUp />} />
      </Route>
      <Route path="confirmation" element={<Confirmation />} />
      <Route path="curbside/:id" element={<Fulfillment />} />
      <Route path="ratings/:id" element={<Rating />} />
      <Route path="loyalty" element={<Loyalty />} />
      <Route path="rewards" element={<Rewards />} />
      <Route path="favorites" element={<Favorites />} />
      <Route path="orders" element={<OrderHistory />} />
      <Route path="orders/:id" element={<Order />} />
      <Route path="quotes/:uuid" element={<Quote />} />
      <Route path="receipts/:uuid" element={<Quote />} />
      <Route path="group-orders" element={<GroupOrders />} />
      <Route path="account">
        <Route index element={<Account />} />
        <Route path="settings" element={<AccountSettings />} />
        <Route path="gift-cards" element={<AccountGiftCards />} />
        <Route path="allergens" element={<AccountAllergens />} />
        <Route path="payment-methods" element={<AccountCreditCards />} />
        <Route path="addresses" element={<AccountAddresses />} />
        <Route path="house-accounts" element={<HouseAccounts />} />
        <Route path="profile" element={<Profile />} />
        <Route path="communications" element={<CommsPrefs />} />
        <Route path="delete" element={<AccountDelete />} />
      </Route>
      <Route path="gift-cards" element={<GiftCards />} />
      <Route path="donations" element={<Donations />} />
      <Route path="deals" element={<Deals />} />
      <Route path="claim-points" element={<ClaimPoints />} />
      <Route path="points-shop" element={<PointsShop />} />
      <Route path="history" element={<History />} />
      <Route path="accessibility" element={<Accessibility />} />
      <Route path="refunds" element={<Refunds />} />
      <Route path="order" element={<Navigate to="/account" replace />} />
      <Route
        path="order/catering"
        element={<Navigate to="/account" replace />}
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default AppRoutes
